import { CloudUploadOutlineIcon } from './CloudUploadOutlineIcon';

/**
 * author: Google
 * id 88ACA1F5-0FDE-4E89-8144-28BA5E5F1B51
 * name cloud-upload-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cloud-upload-outline.svg
 * tags
 * - Cloud 
 * - Weather 
 */
export const BackupOutlineIcon = CloudUploadOutlineIcon;
export default BackupOutlineIcon